import { Howl } from 'howler'
import type sounds from './sounds'

export type Sound = (typeof sounds)[number]

let howl: Howl | undefined

const sprite: { [key in Sound]: [number, number] } = {
  countdown: [0, 943],
  next: [1443, 912],
  start: [2855, 1326],
  'peer-joined-audio': [4681, 1356],
  'peer-joined': [6536, 1348],
  'peer-left-audio': [8385, 1264],
  'accessory-start': [10149, 7419],
  'accessory-reveal': [18067, 2104],
  'accessory-new': [20671, 939],
  'achievement-new': [22110, 819],
  'xp-click': [23429, 76],
  cheering: [24006, 4231],
  'emoji-reaction': [28736, 298],
  'fist-bump': [29534, 607],
  'high-five': [30642, 553],
  hint: [31694, 1121],
  'auto-joined': [33315, 1205],
  silence: [35020, 500],
}

const getHowl = () => {
  if (!howl) {
    const spriteVersion = Object.values(sprite)
      .map((value) => window.btoa(`${value[0]}:${value[1]}`))
      .join('-')
    howl ??= new Howl({
      src: [`/sprite.mp3?v=${spriteVersion}`],
      sprite: sprite,
    })
  }
  return howl
}

export const initialize = () => {
  getHowl().play('silence')
}

export const unload = () => {
  getHowl().stop()
  getHowl().unload()
  howl = undefined
}

export const play = (sound: Sound) => {
  getHowl().play(sound)
}
